<template>
  <div class="login-container">
    <div class="login-logo">
      <img src="/logo/logo.png" alt="续融宝" class="logo-img">
    </div>
    <div v-if="hasWxPending" class="wx-bind-tip">
      <div class="wx-bind-title">检测到微信授权</div>
      <div class="wx-bind-desc">请绑定已有账号，或直接使用手机号注册新账号。</div>
    </div>
    <van-form @submit="onSubmit" class="login-form" :model="loginForm">
      <van-field v-model="loginForm.account" label="账号" placeholder="请输入账号/手机号" left-icon="user-o"
        :rules="[{ required: true }]" input-align="right" clearable />
      <van-field v-model="loginForm.pwd" label="密码" type="password" placeholder="请输入密码" left-icon="lock"
        :rules="[{ required: true }]" input-align="right" clearable />
      <div style="padding: 0px 16px; margin-top: 30px;">
        <van-button round block type="info" native-type="submit" class="login-btn">{{ submitText }}</van-button>
        <van-button v-if="!hasWxPending" round block plain type="success" class="wx-login-btn" :loading="wxAuthLoading" @click="handleWxAuthLogin">
          微信授权登录
        </van-button>
        <van-button v-if="hasWxPending" round block plain type="info" class="register-btn" @click="handleWxRegister">
          微信注册新账号
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import request from "@/utils/request";
import useCache from "@/utils/user";
import { Toast } from 'vant';
import { bindWxAccount, getWxAuthUrl, registerByWx } from "@/api/wxAuth";

export default {
  name: 'Login',
  props: {
    source: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      loginForm: {
        account: '',
        pwd: ''
      },
      wxPending: null,
      wxAuthLoading: false,
    };
  },
  computed: {
    hasWxPending() {
      return !!(this.wxPending && this.wxPending.openId);
    },
    submitText() {
      return this.hasWxPending ? '绑定并登录' : '登录';
    },
  },
  created() {
    this.loadWxPending();
  },
  methods: {
    loadWxPending() {
      const raw = sessionStorage.getItem('wxAuthPending');
      if (!raw) {
        this.wxPending = null;
        return;
      }
      try {
        const data = JSON.parse(raw);
        this.wxPending = data && data.openId ? data : null;
      } catch (error) {
        this.wxPending = null;
      }
    },
    getRedirectRoute() {
      if (this.source === 'credit') {
        return { path: '/credit/home' };
      }
      return { path: '/credit/home' };
    },
    getWxAuthSource() {
      return this.source || 'credit';
    },
    handleLoginSuccess(userData, successText) {
      useCache.cacheUserData(userData);
      sessionStorage.removeItem('wxAuthPending');
      Toast(successText || '登录成功');
      this.$router.replace(this.getRedirectRoute());
    },
    handleWxAuthLogin() {
      if (this.wxAuthLoading) {
        return;
      }
      this.wxAuthLoading = true;
      getWxAuthUrl({
        source: this.getWxAuthSource(),
      }).then((res) => {
        const authUrl = res && res.data && res.data.data;
        if (!authUrl) {
          throw new Error('未获取到微信授权地址');
        }
        window.location.href = authUrl;
      }).catch((err) => {
        this.wxAuthLoading = false;
        Toast((err && err.message) || '获取微信授权地址失败');
      });
    },
    onSubmit() {
      if (this.hasWxPending) {
        this.handleWxBind();
        return;
      }
      const tempForm = Object.assign({}, this.loginForm);
      request.post("/User/AccountMng/Login", tempForm).then((res) => {
        this.handleLoginSuccess(res.data.data, '登录成功');
      }).catch(err => {
        Toast(err.message);
      })
    },
    handleWxBind() {
      const tempForm = Object.assign({}, this.loginForm);
      bindWxAccount({
        openId: this.wxPending.openId,
        account: tempForm.account,
        password: tempForm.pwd,
      }).then((res) => {
        this.handleLoginSuccess(res.data.data, '绑定成功');
      }).catch((err) => {
        Toast(err.message);
      });
    },
    handleWxRegister() {
      if (!this.hasWxPending) {
        return;
      }
      if (!this.loginForm.account || !this.loginForm.pwd) {
        Toast('请输入账号和密码');
        return;
      }
      registerByWx({
        openId: this.wxPending.openId,
        unionId: this.wxPending.unionId,
        nickname: this.wxPending.nickname,
        avatar: this.wxPending.avatar,
        inviterId: this.wxPending.inviterId,
        account: this.loginForm.account,
        password: this.loginForm.pwd,
      }).then((res) => {
        this.handleLoginSuccess(res.data.data, '注册成功');
      }).catch((err) => {
        Toast(err.message);
      });
    },
  }
};
</script>

<style scoped>
.login-container {
  background-color: #F0F4FF;
  min-height: 100vh;
  padding: 0 16px;
}

.login-logo {
  display: flex;
  justify-content: center;
  padding-top: 120px;
}

.wx-bind-tip {
  margin: 24px auto 0;
  max-width: 520px;
  padding: 16px;
  background: rgba(21, 102, 193, 0.08);
  border: 1px solid rgba(21, 102, 193, 0.16);
  border-radius: 12px;
}

.wx-bind-title {
  font-size: 15px;
  font-weight: 600;
  color: #1566C1;
}

.wx-bind-desc {
  margin-top: 8px;
  color: #5B6B8A;
  font-size: 13px;
  line-height: 20px;
}

.login-btn {
  width: 100%;
  padding: 14px;
  border: none;
  margin-top: 20px;
  border-radius: 12px;
  background: #1566C1;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

.register-btn {
  margin-top: 14px;
  border-radius: 12px;
  color: #1566C1;
  border-color: #1566C1;
}

.wx-login-btn {
  margin-top: 14px;
  border-radius: 12px;
}

.logo-img {
  width: 120px;
  height: 120px;
  object-fit: contain;
}

.login-form {
  margin-top: 32px;
  background-color: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}
</style>
